



























import Vue from "vue";
import {
  signInWithEmailAndPassword, sendPasswordResetEmail, UserCredential,
  RecaptchaVerifier, sendEmailVerification, getMultiFactorResolver, MultiFactorError,
  PhoneMultiFactorGenerator, PhoneAuthProvider
} from "firebase/auth";

import { Alert, Prompt, auth } from "../App.vue";
import { BIcon, BIconEye, BIconEyeSlash } from "bootstrap-vue";

const startlogin = "startlogin";
const stoplogin = "stoplogin";

let recaptchaVerifier: RecaptchaVerifier;

export default Vue.extend({

  name: "LoginForm",

  components: {
    BIcon,
    BIconEye,
    BIconEyeSlash
  },

  data() {
    return {
      Email: "",
      Password: "",
      PasswordHidden: true,
    };
  },

  mounted() {
    recaptchaVerifier = new RecaptchaVerifier(auth, "sign-in-button", {
      size: "invisible",
    });
  },

  methods: {
    ResetPassword() {
      Prompt("Enter your email address").then((promptResult) => {
        if (promptResult.clickedOk && promptResult.text) {

          sendPasswordResetEmail(auth, promptResult.text).then(() => Alert("Password reset email sent"));

        } else {
          return null;
        }
      });
    },

    LoginKeyPress(e: KeyboardEvent) {
      if (e.keyCode === 13) {
        this.Login();
      }
    },

    TwoFactorLogin(error: MultiFactorError) {

      this.$emit(startlogin);
      const resolver = getMultiFactorResolver(auth, error);
      let verificationId: string;

      Promise.resolve().then(() => {

        if (resolver.hints.length !== 1) {
          throw new Error("Multiple 2FA resolvers are not supported");
        }

        if (resolver.hints[0].factorId === PhoneMultiFactorGenerator.FACTOR_ID) {

          const phoneInfoOptions = {
            multiFactorHint: resolver.hints[0],
            session: resolver.session
          };
          const phoneAuthProvider = new PhoneAuthProvider(auth);
          return phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);

        } else {
          throw new Error("Unsupported 2FA resolver: " + resolver.hints[0].factorId);
        }

      }).then((result) => {

        verificationId = result;

        // Remove the loading indicator while the user enters the code
        this.$emit(stoplogin);
        return Prompt(
          "Please enter the Firebase App verification code sent to the phone number linked to this account");

      }).then((promptResult) => {

        this.$emit(startlogin);
        const cred = PhoneAuthProvider.credential(verificationId, promptResult.text);

        const multiFactorAssertion =
          PhoneMultiFactorGenerator.assertion(cred);
        // Complete sign-in.
        return resolver.resolveSignIn(multiFactorAssertion);

      }).then((userCredential) => {

        return this.finishSignIn(userCredential);

      }).catch((caughtError) => {

        this.loginError(caughtError);

      }).finally(() => {
        this.$emit(stoplogin);
      });

    },

    loginError(error: any) {

      if (error.message) {
        Alert(error.message);
      } else {
        Alert(error);
      }

    },

    finishSignIn(userCredential: UserCredential): Promise<void> {

      return new Promise<void>((resolve, reject) => {

        Promise.resolve().then(() => {

          if (!userCredential || !userCredential.user) {
            throw new Error("Could not log in");
          }

          if (!userCredential.user.emailVerified) {
            sendEmailVerification(userCredential.user);
            throw new Error("We need to verify your email address. Please check your email for a verification link, and try again.");
          }

          return userCredential.user.getIdToken();

        }).then((token) => {

          this.$emit("user", userCredential, token);
          resolve();

        }).catch(reject);

      });

    },

    Login() {

      this.$emit(startlogin);

      Promise.resolve().then(() => {

        return recaptchaVerifier.verify();

      }).then(() => {

        return signInWithEmailAndPassword(auth, this.Email, this.Password);

      }).then((result) => {

        return this.finishSignIn(result);

      }).catch((error) => {

        if (error.code === "auth/multi-factor-auth-required") {
          this.TwoFactorLogin(error);
        } else {
          this.loginError(error);
        }

      }).finally(() => {

        this.$emit(stoplogin);

      });
    },
  },
});
